import './styles.scss'

import React from 'react'
import { useValues } from 'kea'

import PropTypes from 'prop-types'

import logic from './logic'

const ReviewLine = ({ avgReview100, reviewText, reviewCount, targetSection }) => {
  const { isOnlyReviewNumber } = useValues(logic)
  return (
    <div className='user-rate'>
      <a className='rate-stars' href={targetSection ? `#${targetSection}` : null}>
        <div className='rate-1' style={{ width: Math.ceil(avgReview100 * 1.25 - 3) }} />
      </a>
      <a className='review-text-link' href={targetSection ? `#${targetSection}` : null}>
        <small className='review-text'>({isOnlyReviewNumber ? reviewCount : reviewText})</small>
      </a>
    </div>
  )
}

export default ReviewLine

ReviewLine.propTypes = {
  avgReview100: PropTypes.number,
  reviewText: PropTypes.string,
  reviewCount: PropTypes.number,
  targetSection: PropTypes.string
}
